import React from 'react'

const ToastMessage = ({ message }: { message: string }) => {
  return <div className='toast-inner'>{message}</div>
}

export default ToastMessage
